export const withTotal = (
  counts: Record<string, number> | undefined,
  ...keys: string[]
): Record<string, number> | undefined => {
  if (!counts) return undefined;
  const all = keys.reduce<number>((sum, key) => sum + (counts[key] ?? 0), 0);
  return { ...counts, all };
};
